/* eslint-disable react/prop-types */
import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import FramedPhoto from "./FramedPhoto";
import { Link } from "react-router-dom";
export default function HiItsMe({ image, title = "The person behind the camera.", points = [
    "I love capturing families, seniors, couples, and more!",
    "I am here to walk alongside you in the messy, silly, quiet, beautiful moments — the ones you'll want to remember exactly as they were.",
    "My goal is always to help you create joy-filled memories and provide you with the opportunity to savor life’s precious moments that you can look back on for a lifetime.",
], }) {
    return (React.createElement(Box, { sx: {
            width: "100%",
            py: { xs: 8, md: 12 },
        } },
        React.createElement(Box, { sx: {
                maxWidth: "1200px",
                mx: "auto",
                px: { xs: 3, md: 5 },
                display: "grid",
                /*
                 * Named areas let the title move independently of the text
                 * block on mobile (above the image) while staying visually
                 * stacked with it on desktop, inside the same column — same
                 * grid, two different arrangements, no duplicated markup.
                 */
                gridTemplateAreas: {
                    xs: `"title" "image" "text"`,
                    md: `"image title" "image text"`,
                },
                gridTemplateColumns: {
                    xs: "1fr",
                    md: "1fr 1fr",
                },
                gridTemplateRows: {
                    xs: "auto auto auto",
                    md: "auto 1fr",
                },
                gap: {
                    xs: 4,
                    md: 8,
                    lg: 10,
                },
                alignItems: "stretch",
            } },
            React.createElement(Typography, { component: "h2", sx: {
                    gridArea: "title",
                    fontSize: {
                        xs: 30,
                        md: 40,
                        lg: 46,
                    },
                    lineHeight: 1.12,
                    maxWidth: "520px",
                    alignSelf: { md: "end" },
                    fontFamily: "'Playfair Display', serif",
                } },
                "The person behind the ",
                React.createElement("span", { style: { fontWeight: 700 } }, "C"),
                "amera."),
            React.createElement(Box, { sx: {
                    gridArea: "image",
                    width: "100%",
                    display: "flex",
                } },
                React.createElement(FramedPhoto, { src: image, frameColor: "primary.dark", frameWidth: 2, padding: 0 })),
            React.createElement(Stack, { justifyContent: "center", spacing: { xs: 2.5, md: 3 }, sx: { gridArea: "text" } },
                React.createElement(Box, { component: "ul", sx: {
                        listStyle: "none",
                        m: 0,
                        p: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 1.75, md: 2 },
                    } }, points.map((point) => (React.createElement(Box, { component: "blockquote", key: point, sx: {
                        m: 0,
                        mb: 5,
                        mx: "auto",
                        maxWidth: 560,
                        pl: 3,
                        borderLeft: "2px solid #B9A88F",
                        fontFamily: "'Cormorant Garamond', serif",
                        fontStyle: "italic",
                        fontSize: { xs: "1.25rem", sm: "1.4rem" },
                        lineHeight: 1.5,
                        color: "#1B1812",
                    } }, point)))),
                React.createElement(Box, { sx: { pt: 1 } },
                    React.createElement(Button, { component: Link, to: "/about", variant: "outlined" }, "Learn More"))))));
}
